import axios from 'axios';
import ApiConfig from "../config/ApiConfig";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { saved, saving, couldnotSave, resetStatus } from '../redux/saveSlice';

export const addComment = async (payload, dispatch) => {
  try {
    dispatch(saving());
    const resp = await axios.post(`${ApiConfig.addComment}`, payload);
    if (resp?.data.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return true;
    } else {
      dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
      throw resp;
    }
  } catch (e) {
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    // showErrorMessage(e);
    return false;
  }
};

export const listComments = async (payload, dispatch) => {
  try {
    const resp = await axios.post(`${ApiConfig.listComments}`, payload);
    if (resp?.data.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return resp?.data?.data;
    } else {
      dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
      throw resp;
    }
  } catch (e) {
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    // showErrorMessage(e);
    return false;
  }
}

export const addReply = async (payload, dispatch) => {
  try {
    dispatch(saving());
    const resp = await axios.post(`${ApiConfig.addReply}`, payload);
    if (resp?.data.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return true;
    } else {
      dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
      throw resp;
    }
  } catch (e) {
    // showErrorMessage(e);
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    return false;
  }
}

export const editComment = async (payload, dispatch) => {
  try {
    dispatch(saving());
    const resp = await axios.post(`${ApiConfig.editComment}`, payload);
    if (resp?.data.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return true;
    } else {
      dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
      throw resp;
    }
  } catch (e) {
    // showErrorMessage(e);
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    return false;
  }
}

export const deleteComment = async (payload, dispatch) => {
  try {
    dispatch(saving());
    const resp = await axios.delete(`${ApiConfig.deleteComment}`, { data: payload });
    if (resp?.data.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return true;
    } else {
      dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
      throw resp;
    }
  } catch (e) {
    // showErrorMessage(e);
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    return false;
  }
}

export const listChanges = async (payload, dispatch) => {
  try {
    const resp = await axios.post(`${ApiConfig.listChanges}`, payload);
    if (resp?.data.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return resp?.data?.data;
    } else {
      dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
      throw resp;
    }
  } catch (e) {
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    // showErrorMessage(e);
    return false;
  }
}

export const logChanges = async (payload, dispatch) => {
  try {
    const resp = await axios.post(`${ApiConfig.logChange}`, payload);
    if (resp?.data.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return resp?.data?.data;
    } else {
      dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
      throw resp;
    }
  } catch (e) {
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    // showErrorMessage(e);
    return false;
  }
}
